import type { ReactNode } from 'react';
import { cn } from './format';

export type CardProps = {
  title?: string;
  subtitle?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  padding?: boolean;
};

export function Card({ title, subtitle, actions, children, className, padding = true }: CardProps) {
  return (
    <section
      className={cn(
        'rounded-[var(--radius)] border border-[var(--border-subtle)] bg-[var(--bg-elevated)] shadow-[0_1px_2px_color-mix(in_srgb,var(--brand)_6%,transparent)]',
        className,
      )}
    >
      {(title || actions) && (
        <header className="flex items-start justify-between gap-3 border-b border-[var(--border-subtle)] px-5 py-4">
          <div>
            {title && <h3 className="m-0 text-base font-semibold text-[var(--text)]">{title}</h3>}
            {subtitle && <p className="m-0 mt-1 text-sm text-[var(--text-muted)]">{subtitle}</p>}
          </div>
          {actions}
        </header>
      )}
      <div className={padding ? 'p-5' : undefined}>{children}</div>
    </section>
  );
}
